import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  forwardRef,
  AfterViewInit,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { HttpClient } from '@angular/common/http';
import {
  FormBuilder,
  FormGroup,
  NG_VALUE_ACCESSOR,
  Validators,
} from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';
import { GeneralService } from '../services/general.service';

interface columnsSchema {
  key: string;
  type: string;
  label: string;
  options?: { value: string | number; label: string }[];
}
@Component({
  selector: 'app-recherche',
  templateUrl: './recherche.component.html',
  styleUrls: ['./recherche.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RechercheComponent),
      multi: true,
    },
  ],
})
export class RechercheComponent implements OnInit, AfterViewInit {
  @Input() recherche: string;
  @Input() param: string;
  @Input() param2: string;
  @Input() name: string;
  @Input() style;
  @Input() lateInputVal;
  @Input() required: boolean = false;
  @Input() placeholder: string;
  @Input() numColonneToShow: number = 0;
  @Input() numColonneToReturn: number = 0;
  @Input() api = 'http://unilog.ddns.net:86/api/';
  @Input() disabled: boolean = false;
  @Input() isAddNewLine: boolean = false;
  @Input() dsName: string;
  @Input() columnsSchema: columnsSchema[] = [];
  form: FormGroup;
  // variable pour composon coposons table (ne pas supprimer)

  //row entier ou le coposons recherche setrouve
  @Input() row;

  //la colonne  ou le coposons recherche setrouve
  @Input() column;

  // index du row ou le coposons recherche setrouve
  // cette variable et utile lorseque on'a pas un udentifiant unique dans le tableau
  @Input() indexRow;

  // fin variable pour composon coposons table (ne pas supprimer)
  @Output() formSubmitted: EventEmitter<any> = new EventEmitter<any>();
  @Output() ChampEnter: EventEmitter<String> = new EventEmitter<String>();
  @Output() ChampBlur: EventEmitter<String> = new EventEmitter<String>();
  @Output() KeyUp: EventEmitter<any> = new EventEmitter<any>();
  @Output() KeyDown: EventEmitter<any> = new EventEmitter<any>();
  @Output() lineSelected: EventEmitter<any> = new EventEmitter<any>();
  parentVal: string;
  valueColonneToReturn;
  displayedColumns = [];
  dataSource = new MatTableDataSource();
  hide = true;
  //myControl: FormControl = new FormControl();
  @Input() tbrecherche: any[];
  loading = true;
  exist = false;
  _param = '';
  selectedRow;
  @ViewChild('matInput') matInput: ElementRef;
  event: any;

  constructor(
    private http: HttpClient,
    private fb: FormBuilder,
    private generalService: GeneralService
  ) {}

  ngOnInit() {
    if (this.isAddNewLine) this.form = this.createFormGroup();
  }
  createFormGroup(): FormGroup {
    const group: any = {};

    this.columnsSchema.forEach((column) => {
      if (column.type === 'checkbox') {
        group[column.key] = [null];
      } else {
        group[column.key] = [null, this.mapValidators(column.type)];
      }
    });

    return this.fb.group(group);
  }

  mapValidators(type: string): any[] {
    switch (type) {
      case 'number':
        return [Validators.required, Validators.pattern(/^-?\d*(\.\d+)?$/)];
      case 'date':
        return [Validators.required];
      case 'email':
        return [Validators.required, Validators.email];
      default:
        return [Validators.required];
    }
  }
  onFormSubmit(): void {
    if (this.form.valid) {
      console.log('Form submitted:', this.form.value);
      this.formSubmitted.emit(this.form.value);
      this.postDsAfterFillingIt();
    } else {
      console.error('Form is invalid');
    }
  }

  postDsAfterFillingIt() {
    this.generalService.getDS(this.dsName).subscribe((ds: any) => {
      if (ds) {
        ds[this.dsName][0] = this.generalService.fillObject(
          this.form.value,
          ds[this.dsName][0]
        );
        console.log(ds);
        this.generalService.postDs(ds).subscribe((data) => {
          console.log(data);
          this.form.reset();
        });
      }
    });
  }

  ngAfterViewInit() {
    if (this.lateInputVal)
      setTimeout(() => {
        this.matInput.nativeElement.focus();
        this.matInput.nativeElement.value = this.lateInputVal;
      }, 200);
    this.rechercheTable(this.recherche).subscribe((data) => {
      if (!this.tbrecherche || this.tbrecherche.length == 0)
        this.tbrecherche = data.TableRD;
      //console.log("vv  " +JSON.stringify( this.tbrecherche));
      for (let obj of this.tbrecherche) {
        //    console.log("aa " + obj);
        this.displayedColumns.push(obj['TableRD_Champs']);
      }
      //  console.log("rr " + this.displayedColumns);
      // this.rechercheData(this.recherche, '').subscribe((data) => {
      //   this.dataSource.data = data;
      //   this.exist = true;
      // });
    });
  }

  keyDown(event) {
    console.log(this.parentVal);
    event['valueColonneToReturn'] = this.valueColonneToReturn;
    event['valueColonneToShow'] = this.parentVal;
    this.KeyDown.emit(event);
  }
  keyUp(event) {
    event['valueColonneToReturn'] = this.valueColonneToReturn;
    event['valueColonneToShow'] = this.parentVal;
    this.KeyUp.emit(event);
  }
  keyblur() {
    this.ChampBlur.emit(this.valueColonneToReturn);
  }
  onSelectionChanged(event: MatAutocompleteSelectedEvent) {
    if (event.option.id) {
      this.valueColonneToReturn = event.option.id;
      this.selectedRow = this.dataSource.data.find((row) => {
        return (
          row[this.displayedColumns[this.numColonneToReturn]] == event.option.id
        );
      });

      this.ChampEnter.emit(event.option.id);
      this.lineSelected.emit(this.selectedRow);
    }
  }
  clearText() {
    if (!this.disabled) {
      this.parentVal = '';
      this.valueColonneToReturn = '';
      this.selectedRow = null;
      this.ChampEnter.emit('');
      this.onModif('');
    }
  }
  focusFunction() {
    if (this.param != undefined && this.param != null && this.param != '') {
      console.log('rr : ' + this.param + '  :  ' + this._param);
      this.onModif('');
    }
  }

  rechercheData(codetb: string, codeval) {
    let v1 = '';
    let v2 = '';
    if (codeval) v1 = '&val=' + codeval;
    if (
      (this.param != undefined && this.param != null) ||
      (this.param2 != undefined && this.param2 != null)
    ) {
      v2 = '&param=';
      if (this.param != undefined && this.param != null) v2 += this.param;
      if (this.param2 != undefined && this.param2 != null)
        v2 += ',' + this.param2;
    }
    return this.http.get<any[]>(
      this.api + 'recherche/tbdata?tablere=' + codetb + v1 + v2
    );
  }

  rechercheTable(code: string) {
    return this.http.get<any>(this.api + 'recherche/TbRecherche?param=' + code);
  }

  onModif(event) {
    // console.log('cc::'+ event);
    this.rechercheData(this.recherche, event).subscribe((data) => {
      this.dataSource.data = data;
      // console.log('**'+event+"**");
      if (data.length > 0) this.exist = true;
      else this.exist = false;
    });
    this._onChange(event);
  }

  private _onChange = (_: any) => {};
  // call if input was "touched" .. !
  private _onTouched = () => {};

  // incoming change..
  public writeValue(val: any) {
    if (val) {
      this.parentVal = val;
    }
  }

  public registerOnChange(fn: (_: any) => void): void {
    this._onChange = fn;
  }
  public registerOnTouched(fn: () => void): void {
    this._onTouched = fn;
  }
}
